import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'
import {LeagueKind, LeagueScopeType, LeagueStatus, ILeaguePrizePool, ILeagueSlotId} from './list'

/**
 * GET https://api.leagueoftraders.work/v3/volume-league
 * 공개(trader-facing) 리그 조회 응답 모델.
 * admin/volume-leagues 와 필드가 다르며, 값이 null / undefined 일 수 있어 모두 옵셔널·nullable 처리.
 *
 * 실제 응답 예시(rolling · symbol scope):
 *  { id:30, name:"ACU", kind:"rolling", scope_type:"symbol", status:"active",
 *    group_key:"sym:ACU", group_label:"ACU", symbol:"ACU",
 *    logo:"https://cache.leagueoftraders.io/ACU.png", timeframe:"30D",
 *    window_days:30, refresh_interval_sec:600, prize_pool:null,
 *    last_ranked_at:"...", created_at:"...", updated_at:"..." }
 */
export interface IVolumeLeagueItem {
    id: number
    name?: string | null
    kind?: LeagueKind | null
    scope_type?: LeagueScopeType | null
    status?: LeagueStatus | null
    group_key?: string | null
    group_label?: string | null
    symbol?: string | null
    exchange?: string | null // exchange scope 일 때
    logo?: string | null // 리스트 아이콘 (URL 직접 제공)
    timeframe?: string | null // 예: "30D"
    window_days?: number | null
    refresh_interval_sec?: number | null
    prize_pool?: ILeaguePrizePool | null
    start_at?: string | null // competition
    end_at?: string | null // competition
    total_volume?: number | null // 마지막 랭킹 기준 리그 총 거래량(USD) — share 의 분모
    supported_exchanges?: string[] | null
    exchange_urls?: {[exchange: string]: string} | null // 거래소명 → URL 맵 (표시 전용, 값 없으면 생략)
    url_third_party?: string | null
    sort_value?: number | null // 표시 정렬 가중치 (내림차순, 기본 0)
    slot_id?: ILeagueSlotId | null // 언어별 Slot 식별자 (표시 전용 · 선택)
    last_ranked_at?: string | null
    created_at?: string | null
    updated_at?: string | null
}

// 목록 배열 반환 (단건 객체로 올 경우 hook 에서 배열로 정규화)
export const getVolumeLeague = async (): Promise<ApiRes<IVolumeLeagueItem[]>> => {
    return await apiGet(API_URL, `volume-league`)
}
